import React from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import Heading from 'components/Heading/Heading';
import useQuestionnairePage from 'hooks/useQuestionnairePage';
import { DynamicSubTab } from 'components/DynamicSubTab/DynamicSubTab';
import { useTabs } from 'hooks/useTabs';
import { Section } from 'types';

interface Activities {
  onSubmitFormHandle: (event: any, question: any, handleNext: any, handleSubmit: any, setError: any, message?: string) => void;
}

const Activities: React.FC<Activities> = ({ onSubmitFormHandle }) => {
  const currentTab = 6;
  const {
    subTabQuestions,
    LoadingSpinner,
    confirmationDialog,
    handleOpenConfirmationModal,
    setSubTabQuestions
  } = useQuestionnairePage({ activityFilter: 'A', tabIndex: currentTab });

  const {
    activeTab: activeSubTab,
    setActiveTab: setActiveSubTab,
    enabledTabs: enabledSubTabs,
    completeTab: completeSubTab,
  } = useTabs(subTabQuestions.length);

  const afterSubmit = (index: number, data: any) => {
    completeSubTab(index);

    if (activeSubTab === subTabQuestions.length - 1) {
      handleOpenConfirmationModal()
    }
  }

  const setSubTabQuestionsHandle = (newSections: any, index: number) => {
    
    setSubTabQuestions(prevState =>
        prevState.map((item, i) =>
          i === index
            ? {
                ...item,
                sections: newSections,
              }
            : item
        )
      );

  }

  return (
    <>
      <Box>
        <Box>
          <Heading title="Actividades" />
        </Box>
        <Box>
          <Tabs
            isFitted
            index={activeSubTab}
            size={'md'}
            onChange={index => setActiveSubTab(index)}
          >
            <TabList overflowX="auto" overflowY="hidden" whiteSpace="nowrap">
              {subTabQuestions.map((item, index) => (
                <Tab key={item.sections[0].code} isDisabled={!enabledSubTabs.includes(index)}>
                  {item.sections[0].title}
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              {subTabQuestions.map((item, index) => (
                <TabPanel key={item.sections[0].code}>
                  <DynamicSubTab 
                    question={item} 
                    activityFilter='A' 
                    afterSubmit={data => afterSubmit(index, data)} 
                    parentTab={currentTab} 
                    onTabReset={() => setActiveSubTab(0)}
                    onSubmitFormHandle={onSubmitFormHandle}
                    setSubTabQuestionsHandle={(section: Section[]) => setSubTabQuestionsHandle(section, index)} 
                  />
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Box>
        <LoadingSpinner />
      </Box>
      {confirmationDialog}
    </>
  );
};

export default Activities;
